(function () {
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function init(root) {
    if (!root || root.dataset.fpsnInitialized === 'true') return;

    const panel = root.querySelector('.fpsn__panel');
    const closeButton = root.querySelector('.fpsn__close');
    const triggers = Array.from(document.querySelectorAll(`[aria-controls="${root.id}"][data-fpsn-open]`));
    let returnFocus = null;

    if (!panel || !closeButton || triggers.length === 0) return;
    root.dataset.fpsnInitialized = 'true';

    const isOpen = () => root.classList.contains('is-open');

    function openDrawer(trigger) {
      returnFocus = trigger || document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      triggers.forEach((item) => {
        const itemLabel = item.dataset.fpsnLabel || 'Navigation';
        item.setAttribute('aria-expanded', 'true');
        item.setAttribute('aria-label', `${itemLabel} schließen`);
      });
      document.documentElement.classList.add('fpsn-lock');
      window.requestAnimationFrame(() => closeButton.focus());
    }

    function closeDrawer(restoreFocus) {
      if (!isOpen()) return;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      triggers.forEach((item) => {
        const itemLabel = item.dataset.fpsnLabel || 'Navigation';
        item.setAttribute('aria-expanded', 'false');
        item.setAttribute('aria-label', `${itemLabel} öffnen`);
      });
      document.documentElement.classList.remove('fpsn-lock');
      if (restoreFocus !== false && returnFocus && typeof returnFocus.focus === 'function') {
        returnFocus.focus();
      }
    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        if (isOpen()) {
          closeDrawer(true);
        } else {
          openDrawer(trigger);
        }
      });
    });

    root.querySelectorAll('[data-fpsn-close]').forEach((control) => {
      control.addEventListener('click', () => closeDrawer(true));
    });

    root.querySelectorAll('[data-fpsn-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!submenu) return;
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        submenu.hidden = expanded;
      });
    });

    root.addEventListener('keydown', (event) => {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer(true);
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll(focusableSelector)).filter((item) => {
        return !item.closest('[hidden]') && item.offsetParent !== null;
      });
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth < 990) closeDrawer(false);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-fpsn-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
